import React, { Component } from 'react';
import * as game from '../../controllers';
import BackButton from '../../images/backButton.svg';
import { goBack } from 'react-router-redux';
import { connect } from 'react-redux';

class ResearchView extends Component {
    constructor (props) {
        super(props);
        this.state = {
            research: null
        };
    }

    componentDidMount () {
        game.research.get().then(response => {
            this.setState({research: response});
        });
    }

    showResearches (research) {
        return <div key={research.id}>
            <p>{'Pesquisa: ' + research.title}</p>
            <p>{'Descrição: ' + research.description}</p>
        </div>;
    }

    render () {
        return (
            <div className='answer-background'> {
                (this.state.research !== null)
                    ? <div className='research-dashboard'>
                        <span>{
                            this.showResearches(this.state.research[2])
                        }</span><br />
                    </div>
                    : <div>
                        <div className='auth-dashboard'>
                            <span>Não há nenhuma pesquisa relacionada</span><br />
                        </div>

                    </div>
            }
                <img
                    className='research-button'
                    src={BackButton}
                    alt=''
                    onClick={() => this.props.goBack()} />
                <br />
            </div>
        );
    }
}

export default connect(null, { goBack })(ResearchView);



// WEBPACK FOOTER //
// ./src/views/ResearchView/researchView.js